var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.horizontal != 'true')?_c('div',{staticClass:"footer-box",style:({'background':`url(${_vm.footerBg})`,'background-size': '100% 100%'})},[_c('div',{staticClass:"title textCenter"},[_c('p',{staticClass:"Handwriting"},[_c('img',{staticClass:"imgH",attrs:{"src":_vm.logoImg,"alt":""}}),_vm._v(" "+_vm._s(_vm.name)+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }